<!--
  SupportStatusBadge.svelte — a ticket's status as a coloured badge.

  Named from the reader's side of the desk: the same `awaiting_agent` reads
  "Waiting for support" to the customer and "Awaiting agent" to the team, so
  whoever is looking can tell at a glance whose move it is.
-->
<script lang="ts">
	import { Badge } from 'flowbite-svelte';
	import type { SupportTicketStatus } from '../AppTypes';
	import { SUPPORT_STATUS_COLORS, supportStatusLabel, type SupportAudience } from '../support/supportFormat';
	import { t } from '../i18n';

	interface Props {
		/** The status to show. */
		status: SupportTicketStatus;
		/** Which side of the desk is reading it. */
		audience?: SupportAudience;
		/** Extra classes for the badge. */
		class?: string;
	}

	let { status, audience = 'agent', class: className = '' }: Props = $props();
</script>

<Badge color={SUPPORT_STATUS_COLORS[status] ?? 'gray'} class="whitespace-nowrap {className}">
	{$t(supportStatusLabel(status, audience))}
</Badge>
